
import Cookies from 'js-cookie'
import { getStreamingLink } from '~/plugins/streaming'

export const redirectToStreamingSession = (programId, lotId) => {
  const linkTarget = '_self'

  setTimeout(() => {
    lotId
      ? openLotStreamingLink(programId, lotId, linkTarget)
      : openProgramStreamingLink(programId, linkTarget)
  }, 500)
}

const openProgramStreamingLink = async (programId, linkTarget) => {
  const token = Cookies.get('temp-usr')
  const { link } = await getStreamingLink({ programId, token })

  if (linkTarget === '_self') {
    window.location.href = link
  } else {
    window.open(link, linkTarget)
  }
}

const openLotStreamingLink = async (programId, lotId, linkTarget) => {
  const token = Cookies.get('temp-usr')
  const { link } = await getStreamingLink({ programId, flatId: lotId, token })

  window.open(link, linkTarget)
}
